import React from "react";
import Card from "./cardExpanding";

export default function PlanFAQ(props) {
  const { styles, showTitle } = props;
  const { title } = props.text;
  
  function generateSections(text) {
    const { sections } = text;

    return sections.map((section, sectionIndex) => {
      const { key, question, answer } = section;

      return (
        <Card
          key={key + "_faqFragment_" + sectionIndex}
          header={question}
          content={answer}
          cardStyle={styles.card}
          headerStyle={styles.header}
          contentStyle={styles.content}
          useIcon={true}
          contentType={key}
        />
      );
    });
  }

  return (
    <React.Fragment>
      {showTitle && <div className={styles.title}>{title}</div>}
      {generateSections(props.text)}
    </React.Fragment>
  );
}
